export default () => {
  return {
    connectionConfig: {},
    connections: [],
    connectionsCache: {},
  };
};
